/** @format */

import React, { PureComponent } from 'react';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import ClientEditMvno from '../Clients/Mvno/ClientEdit';

class ClientsEdit extends PureComponent {
    constructor(props, context) {
        super(props, context);
        this.props.handleSetBrandText('clients:c.client');
    }

    render() {
        const { match, partial, classes } = this.props;
        return (
            <GridContainer>
                <GridItem xs={12}>
                    <ClientEditMvno match={match} partial={partial} classes={classes} />
                </GridItem>
            </GridContainer>
        );
    }
}

export default ClientsEdit;
